import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db45b384"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "license-request-content-item p-grid p-nogutter" }
const _hoisted_2 = { class: "p-col-4" }
const _hoisted_3 = { class: "p-col-8 content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"requests-list-header p-grid p-nogutter\" data-v-db45b384><div class=\"p-col-3\" data-v-db45b384><h6 data-v-db45b384>from</h6></div><div class=\"p-col-2\" data-v-db45b384><h6 data-v-db45b384>price</h6></div><div class=\"p-col-2\" data-v-db45b384><h6 data-v-db45b384>start date</h6></div><div class=\"p-col-2\" data-v-db45b384><h6 data-v-db45b384>status</h6></div><div class=\"p-col-3\" data-v-db45b384></div></div>", 1)
const _hoisted_5 = { class: "p-col-3" }
const _hoisted_6 = { class: "p-col-2" }
const _hoisted_7 = { class: "p-col-2" }
const _hoisted_8 = { class: "p-col-2" }
const _hoisted_9 = { class: "p-col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_items_listItem = _resolveComponent("content-items-listItem")!
  const _component_brand_short_preview = _resolveComponent("brand-short-preview")!
  const _component_status_chip = _resolveComponent("status-chip")!
  const _component_license_request_actions = _resolveComponent("license-request-actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_content_items_listItem, { item: _ctx.item }, null, 8, ["item"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.licenseRequests, (request) => {
        return (_openBlock(), _createElementBlock("div", {
          key: request.id,
          class: "requests-list-item p-grid p-nogutter"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_brand_short_preview, {
              brand: request.brand
            }, null, 8, ["brand"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.getRequestLastOffer(request).price) + " " + _toDisplayString(_ctx.item?.campaignId?.budget?.currency), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.formatDate(request.startDate)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_status_chip, {
              status: _ctx.getRequestLastOffer(request).status === 'pending' && _ctx.getRequestLastOffer(request).from
           === 'creator' ? 'counter' : 'pending'
            }, null, 8, ["status"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_license_request_actions, _mergeProps({
              item: _ctx.item,
              request: request,
              viewPerspective: _ctx.viewPerspective
            }, _ctx.$attrs), null, 16, ["item", "request", "viewPerspective"])
          ])
        ]))
      }), 128))
    ])
  ]))
}